<template>
  <el-card class="range">
    <div slot="header">
      {{ config.title }}
      <Tooltip :content="config.tooltip" :contentCustomr="config.tooltipCustomr"></Tooltip>
      <!-- <el-tooltip class="item" effect="dark" placement="top-start">
        <div slot="content">
          <div>{{ config.tooltip }}</div>
        </div>
        <i class="icon-a-01wenhao iconfont-elicon" v-show="config.tooltip" />
      </el-tooltip> -->
    </div>
    <div class="rangeList">
      <template v-if="config.data && config.data.length">
        <div class="bar-item" v-for="item in config.data" :key="item.name">
          <el-tooltip class="item" :content="item.name" placement="top-start">
            <div class="bar-name">{{ item.name }}</div>
          </el-tooltip>
          <el-progress
            :text-inside="true"
            :stroke-width="18"
            :percentage="item.per"
            class="progress"
            :format="
              val => {
                return item.num
              }
            "
          ></el-progress>
        </div>
      </template>
      <ZDefaultData :custom="custom" v-else></ZDefaultData>
    </div>
  </el-card>
</template>

<script>
import ZDefaultData from '@/components/common/default-data/main'
import Tooltip from './tooltip.js'
export default {
  components: { ZDefaultData, Tooltip },
  props: {
    config: {
      default: () => {},
      type: Object,
    },
    custom: {
      default: () => ({ height: '360px', img: require('@/assets/images/emptyDefault/emptyCard.png') }),
      type: Object,
    },
  },
}
</script>

<style lang="scss" scoped>
.icon {
  color: #999;
  font-size: 14px;
  margin-left: 5px;
}
.range {
  position: relative;
  margin-top: 18px;
  /deep/ .el-card__header {
    border-bottom: 0;
    color: #010517;
    font-size: 14px;
    font-weight: normal;
  }
}
.rangeList {
  .bar-item:first-child {
    margin-top: 0px;
  }
}
.bar-item {
  display: flex;
  align-items: center;
  .bar-name {
    width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    opacity: 0.8;
    color: #262626;
  }
  .progress {
    flex: 1;
    margin-left: 10px;
    /deep/.el-progress-bar__inner {
      border-radius: 3px;
      text-align: left;
    }
    /deep/.el-progress-bar__outer {
      border-radius: 3px;
      background: rgba(54, 109, 255, 0.25);
    }
    /deep/.el-progress-bar__innerText {
      margin: 0 8px;
    }
  }
  margin-top: 20px;
}
.progress {
  /deep/.el-popover {
    background: rgba(54, 109, 255, 0.25) !important;
    border: 1px solid rgba(54, 109, 255, 0.25) !important;
  }
  /deep/.popper__arrow::after {
    border-right-color: rgba(54, 109, 255, 0.25) !important;
    color: rgba(54, 109, 255, 0.25) !important;
    left: 0px !important;
  }
  .bar-popover-title {
    font-size: 16px;
    margin-bottom: 20px;
    color: #fff;
    font-weight: bold;
  }
  .bar-popover-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
  }
  .bar-popover-content + .bar-popover-content {
    margin-top: 16px;
  }
}
</style>
<style lang="scss">
.range {
  .icon {
    color: #999;
    font-size: 14px;
    margin-left: 5px;
  }
}
</style>
